import React, { useCallback, useMemo, useState } from 'react';
import { DateRange } from 'shared/types/date-range';
import { ID } from 'shared/types/id';

import { GoalProgressDateRangeContext } from './context';

export type GoalProgressDateRangeProviderProps = {
  children: React.ReactNode;
};

export const GoalProgressDateRangeProvider: React.FC<
  GoalProgressDateRangeProviderProps
> = ({ children }) => {
  const [ranges, setRanges] = useState<Record<ID, DateRange>>({});

  const setRange = useCallback((goalId: ID, range: DateRange) => {
    setRanges((current) => ({ ...current, [goalId]: range }));
  }, []);

  const value = useMemo(() => ({ ranges, setRange }), [ranges, setRange]);

  return (
    <GoalProgressDateRangeContext.Provider value={value}>
      {children}
    </GoalProgressDateRangeContext.Provider>
  );
};
